import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

import {
  getToken,
  getMessaging,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAPOWBDjp9n4CRjSJSYE7ODRhZReFf9cFE",
  authDomain: "touramp-9ed84.firebaseapp.com",
  projectId: "touramp-9ed84",
  storageBucket: "touramp-9ed84.appspot.com",
  messagingSenderId: "369502740128",
  appId: "1:369502740128:web:478d91e661de79e103b3c5",
  measurementId: "G-QHDNGG9VFS",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(firebaseApp);
    }
    return null;
  } catch {
    return null;
  }
})();

export const getOrRegisterServiceWorker = async () => {
  if (
    !("serviceWorker" in navigator) ||
    typeof window.navigator.serviceWorker === "undefined"
  ) {
    return null;
  }

  try {
    const existing = await window.navigator.serviceWorker.getRegistration(
      "/firebase-push-notification-scope"
    );
    if (existing) return existing;

    return await window.navigator.serviceWorker.register(
      "/firebase-messaging-sw.js",
      {
        scope: "/firebase-push-notification-scope",
      }
    );
  } catch (error) {
    console.warn("Firebase service worker registration skipped:", error);
    return null;
  }
};

/** Returns an FCM token when push is available; otherwise undefined (never throws). */
export const getFirebaseToken = async (): Promise<string | undefined> => {
  try {
    if (!("PushManager" in window)) return undefined;

    const messagingResolve = await messaging;
    if (!messagingResolve) return undefined;

    const serviceWorkerRegistration = await getOrRegisterServiceWorker();
    if (!serviceWorkerRegistration) return undefined;

    return await getToken(messagingResolve, {
      vapidKey:
        "BCwC6ohSjTN6aQtGd2xiVCPLj_xB8-zs3fQDI_kUf0Hfo7r-3b5iOEQfAI9wojPd349NNejTSLizxCpGV51FMK0",
      serviceWorkerRegistration,
    });
  } catch (error) {
    // Common on localhost / unsupported push environments:
    // "Registration failed - push service not available"
    console.warn("Firebase push token unavailable:", error);
    return undefined;
  }
};

export const onMessageListener = async () => {
  try {
    const messagingResolve = await messaging;
    if (!messagingResolve) return null;

    return new Promise((resolve) => {
      onMessage(messagingResolve, (payload) => {
        resolve(payload);
      });
    });
  } catch (error) {
    console.warn("Firebase onMessage listener unavailable:", error);
    return null;
  }
};
